import { Component } from '@angular/core';
import { ModalComponent } from '../../../utils/modal/modal.component';
import { FormGroup } from '@angular/forms';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { HttpErrorsService } from '../../../../services/utils/http-errors.service';
import { finalize } from 'rxjs';
import { ApiInterfaceService } from '../../../../services/resources/api-interface.service';
import { ApiInterfaceModel } from '../../../../models/resources/api-interface.model';
import { ApiInterfaceFormComponent } from '../../../forms/api-interface-form/api-interface-form.component';

@Component({
  selector: 'app-new-api-interface-modal',
  imports: [
    ModalComponent,
    ApiInterfaceFormComponent
  ],
  templateUrl: './new-api-interface-modal.component.html',
  styleUrl: './new-api-interface-modal.component.scss'
})
export class NewApiInterfaceModalComponent {
  loading: boolean = false;
  formGroup: FormGroup | undefined;

  constructor(
    private modalRef: MdbModalRef<NewApiInterfaceModalComponent>,
    private httpErrorService: HttpErrorsService,
    private apiInterfaceService: ApiInterfaceService
  ) {}

  submit() {
    this.formGroup!.markAllAsTouched();

    if (this.formGroup!.invalid) return;

    this.loading = true;

    const resource = this.formGroup?.value;

    this.apiInterfaceService
      .create(resource)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (apiInterface: ApiInterfaceModel) => {
          this.modalRef.close(apiInterface);
        },
        error: (e) => {
          this.httpErrorService.handleError(e);
        },
      });
  }

  getValueOf(controlName: string) {
    return this.formGroup?.get(controlName)?.value;
  }
}
